export const isAllowedRedirectUri = (redirectUri: string | null | undefined): boolean => {
  if (!redirectUri) {
    return false;
  }

  try {
    const parsedRedirectUri = new URL(redirectUri);

    // Production: allow https redirects to the same parent domain as the current
    // page (e.g. accounts.ediz.com.br -> app.ediz.com.br), so the post-login
    // `return` route survives. Stays open-redirect-safe (no external domains).
    const redirectParentDomain = parsedRedirectUri.hostname.split('.').slice(1).join('.');
    const currentParentDomain =
      typeof window !== 'undefined' ? window.location.hostname.split('.').slice(1).join('.') : '';
    if (
      parsedRedirectUri.protocol === 'https:' &&
      redirectParentDomain !== '' &&
      redirectParentDomain === currentParentDomain
    ) {
      return true;
    }

    // Allow loopback over http or https: the bundled native app (Capacitor)
    // is served from https://localhost, so the post-login token must be allowed
    // to land back on that same self-origin. Still open-redirect-safe.
    return (
      (parsedRedirectUri.protocol === 'http:' || parsedRedirectUri.protocol === 'https:') &&
      (parsedRedirectUri.hostname === 'localhost' || parsedRedirectUri.hostname === '127.0.0.1')
    );
  } catch {
    return false;
  }
};

export const buildRedirectUriWithToken = (
  redirectUri: string | null | undefined,
  token: string
): string | null => {
  if (!isAllowedRedirectUri(redirectUri)) {
    return null;
  }

  const parsedRedirectUri = new URL(redirectUri);
  parsedRedirectUri.searchParams.set('token', token);

  return parsedRedirectUri.toString();
};
